export const TYPE_LANDING = "landing";
export const TYPE_SHOW = "show";
export const TYPE_DETAIL = "detail";
export const TYPE_AUTHOR = "author";
export const DEFAULT_TITLE = "CBC.ca";
